import { LitElement, html } from "lit";

import sharedStyles from "../../styles/shared.js";
import tableStyles from "../../styles/tables.js";

export default class TaxView extends LitElement {
	render() {
		return html`
    ${sharedStyles}
    ${tableStyles}
      <header class="horizontal-menu-header">
        <router-link to="/tax" exact>
          <a>Selvangivelser</a>
        </router-link>
        <router-link to="/tax/tax-filings">
          <a>Indberetninger</a>
        </router-link>
      </header>
      <slot></slot>
    `;
	}
}

customElements.define("tax-view", TaxView);
